import React, {Component} from 'react';
import {Grid, Col, Row, Button, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
import Select   from 'react-select'
 import {  ADD_SELECTED_SERVICES, CLEAR_SELECTED_SERVICES} from 'actions/actionTypes';
 import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';




export default class AdminServiceSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
              filterOptions: {
                  perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                  from: _.isUndefined(this.props.location.query.from) ? '' : moment(this.props.location.query.from),
                  to: _.isUndefined(this.props.location.query.to) ? '' : moment(this.props.location.query.to),
                //   Deleted:_.isUndefined(this.props.location.query.Deleted) ? 'false' : this.props.location.query.Deleted,
                  ServiceTypes:_.isUndefined(this.props.location.query.ServiceTypes) ? [] : _.map(this.props.location.query.ServiceTypes.split(','), function (item) {
                      var foundItem = _.find(config.services.serviceTypesMap, function (o) {
                          return o.value == item
                      });
                      if (foundItem) {
                          return {'value': item, 'label': foundItem.label}
                      }
                  }),
                Markets:_.isUndefined(this.props.location.query.Markets) ? [] : _.map(this.props.location.query.Markets.split(','), function (item) {
                    var location = _.find(config.warehouseData, function (o) {
                        return o.MarketName == item
                    });
                    if (location) {
                        return {'value': item, 'label': location.MarketName}
                    }
                }),
                  Statuses:_.isUndefined(this.props.location.query.Statuses) ? [] : _.map(this.props.location.query.Statuses.split(','), function (item) {
                          return {'value': item, 'label': item}
                   }),
                  recordIDs:  _.isUndefined(this.props.location.query.recordIDs) ?  [] : _.isArray(this.props.location.query.recordIDs) ?  _.get(this.props.location.query, 'recordIDs', []) : [_.get(this.props.location.query, 'recordIDs')]

              }
        };

     };

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }
    onMarketsSelect(options) {
        var updateOptions = {...this.state.filterOptions, Markets: options};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }
    getSearchParams(filtersChanged = {}) {
         var filterOptions = {...this.state.filterOptions, ...filtersChanged};
         var queryParams = {};
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if (filterOptions.from !== '') {
            queryParams.from = filterOptions.from.toISOString()
        }
        if (filterOptions.to !== '') {
            queryParams.to = filterOptions.to.toISOString()
        }
        if (_.size(filterOptions.Markets) > 0) {
            queryParams.Markets = _.map(filterOptions.Markets, 'value').join(',')
        }
        if (_.size(filterOptions.Statuses) > 0) {
            queryParams.Statuses = _.map(filterOptions.Statuses, 'value').join(',')
        }
        if (_.size(filterOptions.ServiceTypes) > 0) {
            queryParams.ServiceTypes = _.map(filterOptions.ServiceTypes, 'value').join(',')
        }


        if (filterOptions.Deleted  ) {
            queryParams.Deleted = filterOptions.Deleted;
        }
        if (_.size(filterOptions.recordIDs) > 0) {
            queryParams.recordIDs = filterOptions.recordIDs
            queryParams.all= true;
        }
         return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }

    onSelectAllRecordsChange() {
        var self = this;
        if (!this.props.selectAllRecords) {

            this.props.search( {include: ['_id'], all: true}).then(response => {
                this.props.toggleAllRecordsSelection(true)
                console.log('recordIds', response.data);

                self.props.dispatchAction(response.data.data, ADD_SELECTED_SERVICES)
            });
        } else {
            this.props.toggleAllRecordsSelection(false);

            this.props.dispatchAction({}, CLEAR_SELECTED_SERVICES)
        }
    }
    onServiceTimeChange(option, optionName) {
        var updateOptions = {...this.state.filterOptions,  [optionName]: option};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }
    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    render() {
        //console.log('this.state searchbox', this.state  );
         var self = this;
         return (
            <div className="product-search-block">
                <Row  >

                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>


                    {/*<Col md={3} xs={3} className="top10">*/}
                        {/*<Select*/}
                            {/*tabIndex="0"*/}
                            {/*placeholder="Per Page"*/}
                            {/*clearable={false}*/}
                            {/*options={config.perPageSelectOptions}*/}
                            {/*onChange={this.onFilterChange.bind(this)}*/}
                            {/*value={self.state.filterOptions.perPage}*/}
                        {/*/>*/}
                    {/*</Col>*/}

                    <Col md={3} xs={6} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>
                    <Col xs={3} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            multi
                            clearable={false}
                            placeholder="Location"
                            options={   _.map(config.warehouseData, item => {
                                return {value: item.MarketName, label: item.MarketName}
                            })}
                            onChange={this.onMarketsSelect.bind(this)}
                            value={self.state.filterOptions.Markets}
                        />
                    </Col>
                    <Col xs={3} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            multi
                            clearable={false}
                            placeholder="Status"
                            options={   _.map(config.serviceStatusList, item => {
                                return {value: item, label: item}
                            })}
                            onChange={(options)=>{
                                var updateOptions = {...this.state.filterOptions, Statuses: options};
                                this.setState({'filterOptions': updateOptions}, function () {
                                this.props.search();
                            });
                            }}
                            value={self.state.filterOptions.Statuses}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} md={3} className="top10">
                    <Select
                        tabIndex="0"
                        multi
                        clearable={true}
                        placeholder="Types"
                        options={ config.services.serviceTypesMap}
                        onChange={(options) => {
                            var updateOptions = {...this.state.filterOptions, ServiceTypes: options};
                            this.setState({'filterOptions': updateOptions}, function () {
                                this.props.search();
                            });

                        }}
                        value={self.state.filterOptions.ServiceTypes}
                    />

                </Col>
                    <Col md={3} xs={6} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                  onChange={(value) =>this.onServiceTimeChange(value,  'from')}
                                  value={this.state.filterOptions.from}
                                  inputProps={{placeholder: 'From'}}/>
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                  onChange={(value) =>this.onServiceTimeChange(value,  'to')}
                                  value={this.state.filterOptions.to}
                                  inputProps={{placeholder: 'To'}}/>
                    </Col>
                    {/*<Col xs={6} md={3} className="top10">*/}
                        {/*<Select*/}
                            {/*tabIndex="0"*/}
                            {/*clearable={true}*/}
                            {/*placeholder="Deleted"*/}
                            {/*options={[*/}
                                 {/*{value: 'true', label: 'Deleted'},*/}
                                {/*{value: 'false', label: 'Active'}]}*/}
                            {/*onChange={(option) => {*/}
                                 {/*this.setState({*/}
                                    {/*'filterOptions': {*/}
                                        {/*...this.state.filterOptions,*/}
                                        {/*Deleted:option ?  option.value : null,*/}
                                    {/*}*/}
                                {/*}, function () {*/}
                                    {/*this.props.search();*/}
                                {/*});*/}
                            {/*}}*/}
                            {/*value={this.state.filterOptions.Deleted}*/}
                        {/*/>*/}

                    {/*</Col>*/}
                    <Col md={3} xs={3} className="top10">
                        <Button className="btn btn-primary" onClick = {this.onSelectAllRecordsChange.bind(this)} >
                            {this.props.selectAllRecords ? 'Clear selection' : 'Select all' }
                        </Button>
                    </Col>

                    <Col md={3} xs={6} className="pull-right top10">
                        <button className="btn btn-primary pull-right" disabled={this.props.pending} onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>


                </Row>

            </div>
        );

    }
}



